var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bill_addon clr" },
    [
      _c("standart", {
        key: "order_addon_inbox",
        attrs: {
          title: "Службова записка ",
          is_active_result: true,
          is_active_problem: true,
          is_active_title: true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }